import { remoteJSON } from './remote';

export const cancelWithdrawal = async (withdrawalId: number) => {
	const response = (await remoteJSON(`/withdraw/${withdrawalId}/reject`, {
		method: 'POST',
	})) as CancelPendingWithdrawalResponse;

	return response;
};

export const request2faCode = async (data: {
	account_name: string;
	bank_id: string | null;
	swift_code: string | null;
	bank_name: string | null;
}) => {
	const response = await remoteJSON('/verification/bank', {
		method: 'POST',
		body: JSON.stringify(data),
	});
	return response;
};

export const createBankAccount = async (data: {
	account_name: string;
	bank_id: string | null;
	swift_code: string | null;
	bank_name: string | null;
	account_number: string;
	token: string;
}) => {
	const response = await remoteJSON('/users/bank', {
		method: 'POST',
		body: JSON.stringify(data),
	});
	return response;
};

export const withdrawalRequest = async (data: { user_bank_account_id: number; amount: number }) => {
	const response = await remoteJSON('/withdraw', {
		method: 'POST',
		body: JSON.stringify(data),
	});
	return response;
};
